<template>
	<div class="product-list w-full">
		<h2 class="text-center text-3xl font-bold">Our Products</h2>
		<button
			@click="goBack"
			class="flex items-center mb-8 text-primary transition-colors duration-200 hover:text-primary-light group"
		>
			<i
				class="mr-2 text-sm transition-transform duration-200 fas fa-chevron-left group-hover:-translate-x-1"
			></i>
			<span class="font-medium">Back to Categories</span>
		</button>

		<div
			class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 w-3/4 mx-auto gap-3 sm:gap-4 md:gap-5 items-stretch"
		>
			<div
				v-for="product in productsList"
				:key="product._id"
				class="relative overflow-hidden transition-all duration-300 bg-surface border border-border rounded-xl shadow-sm group hover:shadow-lg hover:-translate-y-1 flex flex-col h-full"
			>
				<template v-if="true">
					<div
						class="md:hidden relative w-full h-52 overflow-hidden rounded-t-xl flex-shrink-0"
					>
						<img
							:src="getImageLink(product.name)"
							:alt="product.name"
							class="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
							@error="handleImageError"
						/>
					</div>

					<div class="md:hidden p-3 pb-2">
						<h3
							class="text-sm font-bold text-text-primary leading-tight line-clamp-2"
						>
							{{ product.Name }}
						</h3>
					</div>

					<div class="md:hidden px-3 pb-3 mt-auto">
						<button
							v-if="product.name == 'Motor Private'"
							@click="selectProduct(product)"
							class="w-full px-3 py-2 font-medium rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm bg-primary hover:bg-primary-light text-white hover:-translate-y-0.5 shadow-md"
						>
							Buy now
						</button>
						<button
							v-else
							disabled
							class="w-full px-3 py-2 font-medium rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm bg-gray-400 hover:bg-primary-light text-white hover:-translate-y-0.5 shadow-md"
						>
							Coming Soon
						</button>
					</div>
				</template>

				<div class="hidden md:flex md:flex-col md:h-full">
					<div
						class="relative w-full h-32 sm:h-36 overflow-hidden rounded-t-xl flex-shrink-0"
					>
						<img
							:src="getImageLink(product.name)"
							:alt="product.name"
							class="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105 brightness-95"
							@error="handleImageError"
						/>
						<div
							class="absolute inset-0 bg-gradient-to-r from-transparent to-primary/20 pointer-events-none"
						></div>
					</div>

					<div class="p-4 flex flex-col flex-1">
						<div class="mb-2">
							<h3
								class="text-sm sm:text-base font-bold text-text-primary group-hover:text-primary transition-colors duration-200 leading-tight mb-1 line-clamp-2"
							>
								{{ product.name }}
							</h3>
							<p class="text-xs text-slate-500 truncate">
								{{ product.class_code }}
							</p>
						</div>

						<div class="mb-2">
							<p
								class="text-sm text-text-secondary leading-relaxed line-clamp-2"
							>
								{{ product.description }}
							</p>
						</div>

						<div
							v-if="product.insurancecovertypes.length"
							class="mb-3"
						>
							<h4
								class="text-xs font-semibold text-primary mb-1 uppercase"
							>
								Cover Types
							</h4>
							<ul class="text-sm text-text-secondary space-y-1">
								<li
									v-for="cover in product.insurancecovertypes"
									:key="cover._id"
									class="flex items-start space-x-2"
								>
									<i
										class="fas fa-check text-primary mt-1 text-xs"
									></i>
									<span>{{ cover.name }}</span>
								</li>
							</ul>
						</div>

						<div class="mt-auto pt-3 border-t border-gray-100">
							<button
								v-if="product.name == 'Motor Private'"
								@click="selectProduct(product)"
								class="w-full px-3 py-2 font-medium rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm bg-primary hover:bg-primary-light text-white hover:-translate-y-0.5 shadow-md"
							>
								Buy this product
							</button>
							<button
								v-else
								disabled
								class="w-full px-3 py-2 font-medium rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm bg-gray-400 hover:bg-primary-light text-white hover:-translate-y-0.5 shadow-md"
							>
								Coming Soon
							</button>
						</div>
					</div>
				</div>

				<div
					class="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-primary/20 transition-colors duration-300 pointer-events-none"
				></div>
			</div>
		</div>

		<div
			v-if="!productsList.length"
			class="text-center py-16 col-span-full"
		>
			<div
				class="w-20 h-20 mx-auto mb-6 bg-surface rounded-full flex items-center justify-center"
			>
				<i class="fas fa-shield-alt text-2xl text-text-secondary"></i>
			</div>
			<h3 class="text-xl font-semibold text-text-secondary mb-2">
				No Products Available
			</h3>
			<p class="text-text-secondary">
				Products for this category are coming soon.
			</p>
		</div>
	</div>
</template>

<script>
import VueRouter from 'vue-router';
import { FetchInsuranceClasses } from './api/insurance';
import { mapActions } from 'vuex';

export default {
	name: 'ProductList',
	props: {
		products: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			productsList: [],
		};
	},
	methods: {
		...mapActions('product', ['setClass']),
		// async selectProduct(product) {
		//   if (!product.available) return;
		//   this.$store.dispatch("productType/setProduct", product);

		//   // const res = await FetchClassProduct(product.classCode)
		//   // if(res.status){
		//   //   console.log("data", res.data)
		//   //   // this.$store.dispatch("productType/setInsuranceClass", res.data.result.data);

		//   // }
		//   const routeName = product.routeName;

		//   this.$emit('product-selected', {
		//     ...product,
		//     routeName
		//   });

		//   this.$router.push("/motor/basic-details").catch(error => {
		//     if (error instanceof VueRouter.NavigationDuplicated) {
		//     } else {
		//       throw error;
		//     }
		//   });
		// },

		getImageLink(name) {
			switch (name) {
				case 'Aviation':
					return 'https://www.oldmutual.co.ke/v3/assets/bltdd392fd32dda3ce8/blte97186a94940c41c/67bc62d023f11cfdecf353a5/Aviation_2Column2.jpg';
					break;
				case 'Engineering':
					return 'https://www.pacisinsurance.com/wp-content/uploads/2023/08/Products-profess.-engineers.jpeg';
					break;
				case 'Fire Domestic':
					return 'https://a.storyblok.com/f/162273/1000x750/4e2aa323e9/firefighers-couple-putting-off-fire.jpg/m/400x300/smart/filters:quality(90)';
					break;
				case 'Fire Industrial':
					return 'https://beta.liberty.co.ke/assets/images/Fire%20&%20Perils-100_17589bbe-6fa3-4f2f-86af-270647218bf1_md.webp';
					break;
				case 'Liability':
					return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRh-SEnCoQNojsrf-GL7pb1oaWOBmn-_e35kQ&s';
					break;
				case 'Marine':
					return 'https://ke.cicinsurancegroup.com/wp-content/uploads/2021/09/marine-policy-min.png';
					break;
				case 'Motor Private':
					return 'https://media.licdn.com/dms/image/v2/C4E12AQEl4vw7wZ3nnw/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1560415778692?e=2147483647&v=beta&t=xox1StHbeLiZZJReI4tXkM42qxI_FYPnTUdWLti-7MM';
					break;

				case 'Motor Commercial':
					return 'https://www.ibima.co.ke/6.png';
					break;

				case 'Personal Accident':
					return 'https://aar-insurance.com/media/2023/04/pa-servers-1024x738.webp';
					break;

				case 'Theft':
					return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThLJSsnm_cbEzpw2WydyaeHa_RL2EvD-WOog&s';
					break;

				case "Workmen's Compensation (WIBA)":
					return 'https://media.licdn.com/dms/image/v2/D4D12AQHjj7mTYRV-NQ/article-cover_image-shrink_720_1280/B4DZZ8tRMiHwAI-/0/1745848968529?e=2147483647&v=beta&t=33i7MLjRJIgxhyVBKm3GAvAjj-3lhOl8THa0AF240hY';
					break;

				case 'Medical':
					return 'https://ihubshield.africa/wp-content/uploads/2024/02/UAP-Medical-Insurance-Cover-in-Kenya.jpg';
					break;
				case 'Micro Insurance':
					return 'https://www.republicoftogo.com/var/site/storage/images/toutes-les-rubriques/sante/il-faut-developper-la-microassurance-au-togo/2848115-1-fre-FR/il-faut-developper-la-microassurance-au-togo_i1920.jpg';
					break;
				case 'Miscellaneous':
					return 'https://5.imimg.com/data5/SELLER/Default/2022/2/LJ/AZ/VW/94339269/miscellaneous-insurance.jpg';
					break;

				case 'Motor Commercial PSV':
					return 'https://www.liberty.co.ke/assets/images/HIK-Web-Banners_Terrorism_2a8d141f-493e-46b1-915a-d1a53cb0e3ca_lg.webp';
					break;

				case 'Motor Commercial PSV Tuk Tuk':
					return 'https://insurance.co-opbank.co.ke/wp-content/uploads/2021/10/tuktuk.jpg';
					break;

				case 'Motor Commercial PSV Matatu':
					return 'https://www.kenyanews.go.ke/wp-content/uploads/2025/06/matatu-2-1080x630.jpg';
					break;
			}
		},
		goBack() {
			this.$router.push({ name: 'Home' });
		},
		async selectProduct(product) {
			this.$emit('product-selected', product);
			this.setClass(product);
			this.$router.push('/motor/basic-details').catch(() => {});
		},
		async fetchClasses() {
			try {
				const res = await FetchInsuranceClasses();
				if (res.status) {
					this.productsList = res.data;
				}
			} catch (error) {}
		},

		getButtonText(product) {
			if (product.available) {
				return 'Get Quote';
			} else if (product.comingSoon) {
				return 'Coming Soon';
			} else {
				return 'Unavailable';
			}
		},

		getShortFeature(feature) {
			// Shorten long feature names for better display
			const shortMap = {
				'Third Party Coverage': '3rd Party',
				'Comprehensive Protection': 'Comprehensive',
				'Personal Accident': 'Accident Cover',
				'Roadside Assistance': 'Roadside',
				'Fleet Coverage': 'Fleet',
				'Business Use': 'Commercial',
				'Public Liability': 'Liability',
				'Goods in Transit': 'Transit',
				'Burglary Protection': 'Burglary',
				'Asset Coverage': 'Assets',
				'24/7 Claims': '24/7 Claims',
				'Replacement Value': 'Replacement',
				'Aircraft Coverage': 'Aircraft',
				'Pilot Protection': 'Pilot Cover',
				'Passenger Liability': 'Passengers',
				'Ground Risk': 'Ground Risk',
				'Fire Damage': 'Fire Cover',
				'Weather Protection': 'Weather',
				'Contents Cover': 'Contents',
				'Alternative Accommodation': 'Alt. Housing',
				'Cargo Protection': 'Cargo',
				'Hull Coverage': 'Hull',
				'Transit Insurance': 'Transit',
				'Port Risks': 'Port Risk',
				'Outpatient Cover': 'Outpatient',
				'Inpatient Benefits': 'Inpatient',
				'Dental & Optical': 'Dental/Eye',
				'Specialist Care': 'Specialist',
				'Machinery Cover': 'Machinery',
				'Breakdown Protection': 'Breakdown',
				'Installation Risks': 'Installation',
				'Testing Coverage': 'Testing',
			};

			return shortMap[feature] || feature;
		},

		handleImageError(event) {
			event.target.src =
				'https://images.unsplash.com/photo-1558898268-92ae44e7670e?q=80&w=400&auto=format&fit=crop';
		},

		getCategoryShortName(color) {
			const shortMap = {
				blue: 'Vehicle',
				green: 'Commercial',
				red: 'Security',
				orange: 'Property',
				purple: 'Industrial',
				yellow: 'Credit',
				pink: 'Health',
				sky: 'Aviation',
				teal: 'Marine',
				emerald: 'Retirement',
			};
			return shortMap[color] || 'Insurance';
		},
	},
	mounted() {
		this.fetchClasses();
	},
};
</script>

<style scoped>
.product-list::-webkit-scrollbar {
	width: 6px;
}

.product-list::-webkit-scrollbar-track {
	background: #f1f5f9;
	border-radius: 10px;
}

.product-list::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 10px;
}

.product-list::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

.line-clamp-2 {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	line-clamp: 2;
}

.min-w-0 {
	min-width: 0;
}

@media (max-width: 768px) {
	.product-list {
		@apply px-2;
	}
}

@media (max-width: 1024px) and (min-width: 769px) {
	.product-list {
		@apply px-6;
	}
}
</style>
